import React from 'react';
import {createBrowserRouter, RouterProvider, Navigate} from "react-router-dom";
import PublicLayout from "../pages/layout/PublicLayout";
import ShopLayout from "../pages/layout/ShopLayout";
import AdminLayout from "../pages/layout/AdminLayout";
import Home from "../pages/Home";
import PublicProducts from "../pages/PublicProducts";
import PublicProductDetail from "../pages/PublicProductDetail";
import Blog from "../pages/Blog";
import News from "../pages/News";
import NotFound from "../pages/NotFound";
import AssociatePatient from "../pages/AssociatePatient";
import AssociateMedical from "../pages/AssociateMedical";
import FAQ from "../pages/FAQ";
import Transparency from "../pages/Transparency";
import TransparencyDetail from "../pages/TransparencyDetail";
import AME from "../pages/AME";
import ShopLogin from "../pages/ShopLogin";
import MemberArea from "../pages/MemberArea";
import ClientRegister from "../pages/ClientRegister";
import EmailVerification from "../pages/EmailVerification";
import ShopHome from "../pages/ShopHome";
import ShopProductDetail from "../pages/ShopProductDetail";
import ShopProfileLayout from "../pages/layout/ShopProfileLayout";
import ShopMyAccount from "../pages/shop/ShopMyAccount";
import ShopPrescriptions from "../pages/shop/ShopPrescriptions";
import ShopAddresses from "../pages/shop/ShopAddresses";
import ShopCart from "../pages/shop/ShopCart";
import ShopMyData from "../pages/shop/ShopMyData";
import ShopChangePassword from "../pages/shop/ShopChangePassword";
import ShopOrders from "../pages/shop/ShopOrders";
import ShopOrderDetail from "../pages/shop/ShopOrderDetail";
import ShopPixPayment from "../pages/shop/ShopPixPayment";
import AdminLogin from "../pages/AdminLogin";
import AdminDashboard from "../pages/AdminDashboard";
import AdminFAQList from "../pages/admin/AdminFAQList";
import AdminFAQForm from "../pages/admin/AdminFAQForm";
import AdminBlogList from "../pages/admin/AdminBlogList";
import AdminBlogForm from "../pages/admin/AdminBlogForm";
import AdminStaffList from "../pages/admin/AdminStaffList";
import AdminStaffForm from "../pages/admin/AdminStaffForm";
import AdminSiteSettings from "../pages/admin/AdminSiteSettings";
import AdminCategoryList from "../pages/admin/AdminCategoryList";
import AdminCategoryForm from "../pages/admin/AdminCategoryForm";
import AdminProductList from "../pages/admin/AdminProductList";
import AdminProductForm from "../pages/admin/AdminProductForm";
import AdminShippingRateList from "../pages/admin/AdminShippingRateList";
import AdminShippingRateForm from "../pages/admin/AdminShippingRateForm";
import AdminPrescriptionList from "../pages/admin/AdminPrescriptionList";
import AdminPrescriptionDetail from "../pages/admin/AdminPrescriptionDetail";
import AdminOrderList from "../pages/admin/AdminOrderList";
import AdminOrderDetail from "../pages/admin/AdminOrderDetail";
import AdminClientList from "../pages/admin/AdminClientList";
import AdminClientDetail from "../pages/admin/AdminClientDetail";
import AdminReportsPatients from "../pages/admin/AdminReportsPatients";
import AdminReportsEcommerce from "../pages/admin/AdminReportsEcommerce";
import AdminReportsGenerated from "../pages/admin/AdminReportsGenerated";
import AdminAuditLogList from "../pages/admin/AdminAuditLogList";
import {ROUTES} from "../constants/PathRoutes";
import {AdminAuthProvider} from "../contexts/AdminAuthContext";
import {ClientAuthProvider} from "../contexts/ClientAuthContext";
import {ShopProvider} from "../contexts/ShopContext";

const router = createBrowserRouter([
    // Rotas Públicas
    {
        path: ROUTES.HOME,
        element: <PublicLayout/>,
        children: [
            {
                index: true,
                element: <Home/>
            },
            {
                path: ROUTES.LOJA_LOGIN,
                element: <ShopLogin/>
            },
            {
                path: ROUTES.PRODUTOS,
                children: [
                    {
                        index: true,
                        element: <PublicProducts/>
                    },
                    {
                        path: ROUTES.PRODUTOS_DETAIL,
                        element: <PublicProductDetail/>
                    }
                ]
            },
            {
                path: ROUTES.BLOG,
                children: [
                    {
                        index: true,
                        element: <Blog/>
                    },
                    {
                        path: ROUTES.BLOG_DETAIL,
                        element: <News/>
                    }
                ]
            },
            {
                path: ROUTES.ASSOCIADO,
                children: [
                    {
                        path: ROUTES.ASSOCIADO_PACIENTE,
                        element: <AssociatePatient/>
                    },
                    {
                        path: ROUTES.ASSOCIADO_MEDICO,
                        element: <AssociateMedical/>
                    }
                ]
            },
            {
                path: ROUTES.FAQ,
                element: <FAQ/>
            },
            {
                path: ROUTES.TRANSPARENCIA,
                children: [
                    {
                        index: true,
                        element: <Transparency/>
                    },
                    {
                        path: ROUTES.TRANSPARENCIA_DETAIL,
                        element: <TransparencyDetail/>
                    }
                ]
            },
            {
                path: ROUTES.AME,
                element: <AME/>
            },
            // {
            //     path: ROUTES.AREA_ASSOCIADO,
            //     element: <MemberArea/>
            // }
        ]
    },

    // Rotas da Loja (Cliente) - Com Autenticação

    {
        path: ROUTES.AREA_ASSOCIADO,
        element: <ClientAuthProvider/>,
        children: [
            {
                path: ROUTES.AREA_ASSOCIADO_LOGIN,
                element: <PublicLayout/>,
                children: [
                    {
                        index: true,
                        element: <MemberArea/>
                    },
                ]
            },
            {
                path: ROUTES.AREA_ASSOCIADO_CADASTRO,
                element: <PublicLayout/>,
                children: [
                    {
                        index: true,
                        element: <ClientRegister/>
                    },
                ]
            },
            {
                path: ROUTES.AREA_ASSOCIADO_VERIFICAR_EMAIL,
                element: <PublicLayout/>,
                children: [
                    {
                        index: true,
                        element: <EmailVerification/>
                    },
                ]
            },
            {
                path: ROUTES.LOJA_BASE,
                element: <ShopProvider><ShopLayout/></ShopProvider>,
                children: [
                    {
                        path: ROUTES.LOJA_PRODUTOS,
                        children: [
                            { index: true, element: <ShopHome/> },
                            { path: ROUTES.LOJA_PRODUTO_DETAIL, element: <ShopProductDetail/> },
                        ]
                    },
                    {
                        path: ROUTES.LOJA_CARRINHO,
                        element: <ShopCart/>,
                    },
                    {
                        path: ROUTES.LOJA_PERFIL,
                        element: <ShopProfileLayout/>,
                        children: [
                            { index: true, element: <Navigate to={ROUTES.LOJA_MEUS_DADOS} replace/> },
                            { path: ROUTES.LOJA_MEUS_DADOS, element: <ShopMyData/> },
                            { path: ROUTES.LOJA_PRESCRICOES, element: <ShopPrescriptions/> },
                            { path: ROUTES.LOJA_ENDERECOS, element: <ShopAddresses/> },

                            { path: ROUTES.LOJA_MEUS_PEDIDOS, element: <ShopOrders/> },
                            { path: ROUTES.LOJA_PEDIDO_DETAIL, element: <ShopOrderDetail/> },
                            { path: ROUTES.LOJA_PEDIDO_PIX, element: <ShopPixPayment/> },
                            { path: ROUTES.LOJA_ALTERAR_SENHA, element: <ShopChangePassword/> },
                        ]
                    }
                ]
            }
        ]
    },

    // Rotas do Admin - Com Autenticação
    {
        path: ROUTES.ADMIN,
        element: <AdminAuthProvider/>,
        children: [
            {
                index: true,
                element: <AdminLogin/>
            },
            {
                path: ROUTES.ADMIN_AUTH,
                element: (
                    <AdminLayout/>
                ),
                children: [
                    {
                        path: ROUTES.ADMIN_DASHBOARD,
                        element: <AdminDashboard/>
                    },
                    {
                        path: ROUTES.ADMIN_USUARIOS,
                        element: <div>Gerenciamento de Usuários (Em
                            desenvolvimento)</div>
                    },
                    {
                        path: ROUTES.ADMIN_BLOG_LIST,
                        children: [
                            {
                                index: true,
                                element: <AdminBlogList/>
                            },
                            {
                                path: ROUTES.ADMIN_BLOG_CREATE,
                                element: <AdminBlogForm/>
                            },
                            {
                                path: ROUTES.ADMIN_BLOG_EDIT,
                                element: <AdminBlogForm/>
                            }
                        ]
                    },
                    {
                        path: ROUTES.ADMIN_FAQ_LIST,
                        children: [
                            {
                                index: true,
                                element: <AdminFAQList/>
                            },
                            {
                                path: ROUTES.ADMIN_FAQ_CREATE,
                                element: <AdminFAQForm/>
                            },
                            {
                                path: ROUTES.ADMIN_FAQ_EDIT,
                                element: <AdminFAQForm/>
                            }
                        ]
                    },
                    {
                        path: ROUTES.ADMIN_STAFF_LIST,
                        children: [
                            {
                                index: true,
                                element: <AdminStaffList/>
                            },
                            {
                                path: ROUTES.ADMIN_STAFF_CREATE,
                                element: <AdminStaffForm/>
                            },
                            {
                                path: ROUTES.ADMIN_STAFF_EDIT,
                                element: <AdminStaffForm/>
                            }
                        ]
                    },
                    {
                        path: ROUTES.ADMIN_ECOMMERCE_CATEGORY_LIST,
                        children: [
                            {
                                index: true,
                                element: <AdminCategoryList/>
                            },
                            {
                                path: ROUTES.ADMIN_ECOMMERCE_CATEGORY_CREATE,
                                element: <AdminCategoryForm/>
                            },
                            {
                                path: ROUTES.ADMIN_ECOMMERCE_CATEGORY_EDIT,
                                element: <AdminCategoryForm/>
                            }
                        ]
                    },
                    {
                        path: ROUTES.ADMIN_ECOMMERCE_PRODUCT_LIST,
                        children: [
                            {
                                index: true,
                                element: <AdminProductList/>
                            },
                            {
                                path: ROUTES.ADMIN_ECOMMERCE_PRODUCT_CREATE,
                                element: <AdminProductForm/>
                            },
                            {
                                path: ROUTES.ADMIN_ECOMMERCE_PRODUCT_EDIT,
                                element: <AdminProductForm/>
                            }
                        ]
                    },
                    {
                        path: ROUTES.ADMIN_ECOMMERCE_SHIPPING_LIST,
                        children: [
                            {
                                index: true,
                                element: <AdminShippingRateList/>
                            },
                            {
                                path: ROUTES.ADMIN_ECOMMERCE_SHIPPING_EDIT,
                                element: <AdminShippingRateForm/>
                            }
                        ]
                    },
                    {
                        path: ROUTES.ADMIN_ECOMMERCE_PRESCRIPTION_LIST,
                        children: [
                            {
                                index: true,
                                element: <AdminPrescriptionList/>
                            },
                            {
                                path: ROUTES.ADMIN_ECOMMERCE_PRESCRIPTION_DETAIL,
                                element: <AdminPrescriptionDetail/>
                            }
                        ]
                    },
                    {
                        path: ROUTES.ADMIN_ECOMMERCE_ORDER_LIST,
                        children: [
                            {
                                index: true,
                                element: <AdminOrderList/>
                            },
                            {
                                path: ROUTES.ADMIN_ECOMMERCE_ORDER_DETAIL,
                                element: <AdminOrderDetail/>
                            }
                        ]
                    },
                    {
                        path: ROUTES.ADMIN_CLIENT_LIST,
                        children: [
                            {
                                index: true,
                                element: <AdminClientList/>
                            },
                            {
                                path: ROUTES.ADMIN_CLIENT_DETAIL,
                                element: <AdminClientDetail/>
                            }
                        ]
                    },
                    {
                        path: ROUTES.ADMIN_REPORTS_PATIENTS,
                        element: <AdminReportsPatients/>
                    },
                    {
                        path: ROUTES.ADMIN_REPORTS_ECOMMERCE,
                        element: <AdminReportsEcommerce/>
                    },
                    {
                        path: ROUTES.ADMIN_REPORTS_GENERATED,
                        element: <AdminReportsGenerated/>
                    },
                    {
                        path: ROUTES.ADMIN_SITE_SETTINGS,
                        element: <AdminSiteSettings/>
                    },
                    {
                        path: ROUTES.ADMIN_AUDIT_LOG_LIST,
                        element: <AdminAuditLogList/>
                    }
                ]
            },

        ]
    },


    // Rota 404
    {
        path: ROUTES.NOT_FOUND,
        element: <NotFound/>
    }
]);

export default function Routes() {
    return <RouterProvider router={router}/>;
}